module.exports = __webpack_public_path__ + "static/media/ad1.2d657b55.png";